// HC_CUSTOM JS by Studio Boskant — maintained by Shapes Graphic Studio

// Add class section handle type to sections wrappers
document.querySelectorAll(".shopify-section").forEach(function (sec) {
  var matches = sec.id && sec.id.match(/__([a-zA-Z0-9\-_]+)/);
  if (matches && matches[1]) {
    sec.classList.add("section--" + matches[1]);
  }
});

/* ======================
// Dropdowns: markets + language
// ====================== */
(function () {
  const TYPES = [
    {
      root: "[data-markets-dropdown]",
      trigger: "[data-markets-trigger]",
      panel: "[data-markets-panel]",
    },
    {
      root: "[data-language-dropdown]",
      trigger: "[data-language-trigger]",
      panel: "[data-language-panel]",
    },
  ];

  const ROOTS = TYPES.map(function (t) {
    return t.root;
  }).join(", ");

  const TRIGGERS = TYPES.map(function (t) {
    return t.trigger;
  }).join(", ");

  function getTypeFromRoot(root) {
    for (var i = 0; i < TYPES.length; i++) {
      if (root.matches(TYPES[i].root)) return TYPES[i];
    }
    return null;
  }

  function getParts(root) {
    var type = getTypeFromRoot(root);
    if (!type) return null;

    var btn = root.querySelector(type.trigger);
    var panel = root.querySelector(type.panel);

    if (!btn || !panel) return null;

    return {
      btn: btn,
      panel: panel,
    };
  }

  function open(root) {
    var parts = getParts(root);
    if (!parts) return;

    closeAll(root);

    parts.panel.hidden = false;
    parts.btn.setAttribute("aria-expanded", "true");
    root.classList.add("is-open");
  }

  function close(root) {
    var parts = getParts(root);
    if (!parts) return;

    parts.panel.hidden = true;
    parts.btn.setAttribute("aria-expanded", "false");
    root.classList.remove("is-open");
  }

  function closeAll(except) {
    document.querySelectorAll(ROOTS).forEach(function (root) {
      if (except && root === except) return;
      close(root);
    });
  }

  document.addEventListener("click", function (e) {
    var languageOption = e.target.closest("[data-language-option]");

    if (languageOption) {
      var languageRoot = languageOption.closest("[data-language-dropdown]");
      if (!languageRoot) return;

      e.preventDefault();
      e.stopPropagation();

      var form = languageRoot.closest("form");
      var languageSelector = languageRoot.closest(".language-selector");
      var select =
        languageRoot.querySelector('select[name="language_code"]') ||
        (languageSelector
          ? languageSelector.querySelector('select[name="language_code"]')
          : null) ||
        (form ? form.querySelector('select[name="language_code"]') : null);

      var code = languageOption.getAttribute("data-lang");

      if (!form || !select || !code) return;

      select.value = code;
      close(languageRoot);

      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.submit();
      }

      return;
    }

    var trigger = e.target.closest(TRIGGERS);

    if (trigger) {
      var root = trigger.closest(ROOTS);
      if (!root) return;

      e.preventDefault();
      e.stopPropagation();

      var parts = getParts(root);
      if (!parts) return;

      var isOpen = !parts.panel.hidden;

      if (isOpen) {
        close(root);
      } else {
        open(root);
      }

      return;
    }

    if (!e.target.closest(ROOTS)) {
      closeAll();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeAll();
    }
  });
})();

/* ======================
// Swatches carousel (arrows only)
// ====================== */
(function () {
  const FIELDSET =
    "variant-picker fieldset.variant-option--buttons.variant-option--swatches";
  const NAV = ".hc-variant-nav[data-hc-variant-nav]";
  const PREV = "[data-hc-variant-prev]";
  const NEXT = "[data-hc-variant-next]";

  function findNavForFieldset(fieldset) {
    // nav immediately after the fieldset in the markup
    let el = fieldset.nextElementSibling;
    while (el) {
      if (el.matches && el.matches(NAV)) return el;
      if (el.tagName === "FIELDSET") break;
      el = el.nextElementSibling;
    }
    return null;
  }

  function updateState(scroller, nav, prevBtn, nextBtn) {
    const max = scroller.scrollWidth - scroller.clientWidth;
    const hasOverflow = max > 2;

    if (!hasOverflow) {
      nav.style.display = "none";
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    nav.style.display = "";
    const x = scroller.scrollLeft;
    prevBtn.disabled = x <= 2;
    nextBtn.disabled = x >= max - 2;
  }

  function initOne(fieldset) {
    const nav = findNavForFieldset(fieldset);
    if (!nav) return;

    const prevBtn = nav.querySelector(PREV);
    const nextBtn = nav.querySelector(NEXT);
    if (!prevBtn || !nextBtn) return;

    if (fieldset.dataset.hcVariantNavInit === "1") {
      requestAnimationFrame(() => updateState(fieldset, nav, prevBtn, nextBtn));
      return;
    }
    fieldset.dataset.hcVariantNavInit = "1";

    const scrollAmount = () =>
      Math.max(240, Math.floor(fieldset.clientWidth * 0.8));
    const onUpdate = () => updateState(fieldset, nav, prevBtn, nextBtn);

    prevBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (prevBtn.disabled) return;
      fieldset.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
    });

    nextBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (nextBtn.disabled) return;
      fieldset.scrollBy({ left: scrollAmount(), behavior: "smooth" });
    });

    fieldset.addEventListener("scroll", onUpdate, { passive: true });
    window.addEventListener("resize", onUpdate);

    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(onUpdate);
      ro.observe(fieldset);
      fieldset._hcVariantRO = ro;
    }

    requestAnimationFrame(onUpdate);
    setTimeout(onUpdate, 250);
  }

  function initAll(root) {
    (root || document).querySelectorAll(FIELDSET).forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  const mo = new MutationObserver(() => initAll(document));
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ======================
// Breadcrumb — save/restore collection scroll position
// ====================== */
(function () {
  if (!window.location.pathname.includes('/collections/')) return;

  function getScrollTop() {
    const el = document.scrollingElement || document.documentElement;
    return el ? (el.scrollTop || 0) : (window.scrollY || 0);
  }

  function saveContext() {
    try {
      sessionStorage.setItem('hc:return:url', window.location.href);
      sessionStorage.setItem('hc:return:scroll', String(getScrollTop()));
      sessionStorage.setItem('hc:return:ts', String(Date.now()));
    } catch (e) {}
  }

  document.addEventListener('pointerdown', function (e) {
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    // Ignore links that don't navigate (quick-add, anchors, etc.)
    const href = link.getAttribute('href') || '';
    if (!href.includes('/products/')) return;

    saveContext();
  }, { capture: true });

  window.addEventListener('pagehide', saveContext);
})();

// Restore scroll position when returning from a product page via the breadcrumb
(function () {
  if (!window.location.pathname.includes('/collections/')) return;
  if (!window.location.hash.includes('hc-return')) return;

  function restore() {
    try {
      const y = parseInt(sessionStorage.getItem('hc:return:scroll') || '0', 10);
      const el = document.scrollingElement || document.documentElement;
      if (!isNaN(y) && el) el.scrollTop = y;
    } catch (e) {}
  }

  requestAnimationFrame(restore);
  setTimeout(restore, 120);
})();

/* ======================
// Breadcrumb — product return link
// ====================== */
(function () {
  if (!window.location.pathname.match(/\/products\//)) return;

  function run() {
    const returnLink =
      document.getElementById('hcReturnLink') ||
      document.querySelector('a.product-return');

    if (!returnLink) return false;

    const fallbackUrl =
      returnLink.getAttribute('data-fallback-url') ||
      returnLink.getAttribute('href') ||
      '/';

    function isSameSite(url) {
      try { return new URL(url, location.origin).origin === location.origin; }
      catch (e) { return false; }
    }

    function getCtxHref() {
      try {
        const url = sessionStorage.getItem('hc:return:url');
        const ts = parseInt(sessionStorage.getItem('hc:return:ts') || '0', 10);
        const maxAgeMs = 2 * 60 * 60 * 1000;
        if (!url || !ts || (Date.now() - ts) > maxAgeMs) return null;
        if (!isSameSite(url)) return null;
        if (!url.includes('/collections/')) return null;
        return url.split('#')[0] + '#hc-return';
      } catch (e) {
        return null;
      }
    }

    const ctxHref = getCtxHref();

    if (ctxHref) {
      returnLink.setAttribute('href', ctxHref);
    } else if (document.referrer && isSameSite(document.referrer)) {
      returnLink.setAttribute('href', document.referrer);
    } else {
      returnLink.setAttribute('href', fallbackUrl);
    }

    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (run() || tries > 20) clearInterval(timer);
  }, 100);
})();


/* ======================
// Gift wrapping toggle (snippets/hc-gift-wrap.liquid, rendered in cart-summary)
// Adds/removes the "gift-wrapping" product, then dispatches the theme's own
// CartLinesUpdateEvent so the drawer / cart page re-render in place (no reload,
// drawer stays open). Falls back to a page reload if anything goes wrong.
// ====================== */
(function () {
  function sectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) {
        return el.dataset.sectionId;
      })
      .filter(Boolean)
      .join(',');
  }

  async function postJson(url, payload) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  }

  document.addEventListener('change', async function (event) {
    const box = event.target.closest && event.target.closest('[data-hc-gift-wrap]');
    if (!box) return;

    const adding = box.checked;
    const routes = (window.Theme && window.Theme.routes) || {};
    const sections = sectionIds();
    box.disabled = true;

    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferred = CartLinesUpdateEvent.createPromise();

      box.dispatchEvent(
        new CartLinesUpdateEvent({
          // 'update' rather than 'add' so the cart drawer doesn't treat this as an add-to-cart (auto-open)
          action: adding ? 'update' : 'remove',
          context: 'cart',
          lines: adding
            ? [{ merchandiseId: box.dataset.variantId, quantity: 1 }]
            : [{ id: box.dataset.lineKey, quantity: 0 }],
          promise: deferred.promise,
        })
      );

      try {
        let sectionsHtml;
        if (adding) {
          const added = await postJson(routes.cart_add_url || '/cart/add.js', {
            items: [{ id: Number(box.dataset.variantId), quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          });
          sectionsHtml = added.sections;
        } else {
          const changed = await postJson(routes.cart_change_url || '/cart/change', {
            id: box.dataset.lineKey,
            quantity: 0,
            sections: sections,
            sections_url: window.location.pathname,
          });
          sectionsHtml = changed.sections;
        }

        const cart = await fetch((routes.cart_url || '/cart') + '.js').then(function (r) {
          return r.json();
        });

        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            itemCount: cart.item_count,
            sections: sectionsHtml,
            source: 'hc-gift-wrap',
            didError: false,
          },
        });

        // Anything that wasn't re-rendered by a section (should not happen) → hard refresh
        if (!sectionsHtml || !Object.keys(sectionsHtml).length) window.location.reload();
      } catch (error) {
        deferred.reject(error);
        throw error;
      }
    } catch (error) {
      console.error('[hc-gift-wrap]', error);
      window.location.reload();
    }
  });
})();
